export const splitIntoParagraphs = (text: string): string[] =>
  text
    .split(/\r?\n+/)
    .map((p) => p.trim())
    .filter(Boolean);
